import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import _ from 'lodash';

export class TsumRecordExcel {
  constructor(recordId, record, recordDetails, images) {
    this.recordId = recordId;
    this.record = record;
    this.recordDetails = recordDetails;
    this.images = images;
  }

  makeExcel() {
    this.workbook = new ExcelJS.Workbook();
    this.initWorkbook();
    this.makeSummary();
    this.makeUserStatus();

    this.workbook.xlsx.writeBuffer().then(data => {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      saveAs(blob, `xrobotmon-${this.recordId}.xlsx`);
    });
  }

  initWorkbook() {
    this.workbook.creator = 'XRobotmon';
    this.workbook.lastModifiedBy = 'XRobotmon';
    this.workbook.created = new Date();
    this.workbook.modified = new Date();
    this.workbook.lastPrinted = new Date();
    this.workbook.views = [
      {
        x: 0,
        y: 0,
        width: 10000,
        height: 20000,
        firstSheet: 0,
        activeTab: 1,
        visibility: 'visible'
      }
    ];
  }

  async makeUserStatus() {
    const sheet = this.workbook.addWorksheet('UserDetail');
    sheet.columns = [
      { header: 'User', key: 'user', width: 32 },
      { header: 'Sum', key: 'sum', width: 12 },
      { header: 'Average', key: 'avg', width: 12 }
    ];
    const months = Object.keys(this.recordDetails).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    const rowHeader = sheet.getRow(1);
    rowHeader.getCell('user').value = 'User';
    rowHeader.getCell('sum').value = 'Sum';
    rowHeader.getCell('avg').value = 'Average';

    let rowIdx = 2;
    const userIds = Object.keys(this.record);
    for (const userId of userIds) {
      // user image
      if (userId.indexOf('.png') === -1) {
        continue;
      }
      if (this.images[userId].bigbuffer === undefined) {
        continue;
      }
      const row = sheet.getRow(rowIdx);
      row.height = 48;

      // values
      let sum = 0;
      let not0 = 0;
      let cellIdx = 4;
      for (const month of months) {
        const monthData = this.recordDetails[month];
        for (const dayStr in monthData.receiveDays) {
          const day = Number.parseInt(dayStr);
          const date = new Date();
          date.setFullYear(monthData.year, monthData.month, day + 1);
          if (date.getMonth() !== monthData.month) {
            break;
          }
          if (rowIdx === 2) {
            sheet.getColumn(cellIdx).width = 5;
            rowHeader.getCell(cellIdx).value = `${monthData.month + 1}-${day + 1}`;
          }
          const cell = row.getCell(cellIdx);
          const value = _.get(monthData, `receiveUserDays['${userId}'][${day}]`, 0);
          cell.value = value || '';
          if (value > 0) {
            sum += +value;
            not0 += 1;
          } else {
            sum += 0;
            not0 += 0;
          }
          cellIdx++;
        }
      }
      if (sum > 0) {
        const imageId2 = this.workbook.addImage({
          buffer: this.images[userId].bigbuffer,
          extension: 'png'
        });
        sheet.addImage(imageId2, {
          tl: { col: 0, row: rowIdx - 1 },
          ext: { width: 180, height: 60 },
          editAs: 'absolute'
        });
        row.getCell('sum').value = sum;
        if (not0 !== 0) {
          row.getCell('avg').value = Math.ceil(sum / not0);
        } else {
          row.getCell('avg').value = 0;
        }
        rowIdx++;
      }
    }
  }

  makeSummary() {
    const summarySheet = this.workbook.addWorksheet('Summary');
    summarySheet.columns = [
      { header: 'Date', key: 'date', width: 12 },
      { header: 'Receive Hearts', key: 'receive', width: 12 },
      { header: 'Send Hearts', key: 'send', width: 12 },
      { header: 'Play Game', key: 'play', width: 12 }
    ];
    // small -> big
    const months = Object.keys(this.recordDetails).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    const rowHeader = summarySheet.getRow(1);
    rowHeader.getCell('date').value = 'Date';
    rowHeader.getCell('receive').value = 'Receive Hearts';
    rowHeader.getCell('send').value = 'Send Hearts';
    rowHeader.getCell('play').value = 'Play Game';
    let rowIdx = 2;
    for (const month of months) {
      const monthData = this.recordDetails[month];
      for (const dayStr in monthData.receiveDays) {
        const day = Number.parseInt(dayStr);
        const row = summarySheet.getRow(rowIdx);
        const date = new Date();
        date.setFullYear(monthData.year, monthData.month, day + 1);
        if (date.getMonth() !== monthData.month) {
          break;
        }
        row.getCell('date').value = `${monthData.year}-${monthData.month + 1}-${day + 1}`;
        row.getCell('receive').value = monthData.receiveDays[day];
        row.getCell('send').value = monthData.sendDays[day];
        row.getCell('play').value = monthData.playGameDays[day];
        rowIdx++;
      }
    }
  }
}
